var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmarkGreen = function SvgCheckmarkGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 31"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B8E986",
    fillRule: "nonzero",
    d: "m22.194 9.054-9.61 9.61-5.236-5.22L5.292 15.5l7.291 7.292L24.25 11.125zM15.5.917C7.45.917.917 7.45.917 15.5S7.45 30.083 15.5 30.083 30.083 23.55 30.083 15.5 23.55.917 15.5.917m0 26.25c-6.446 0-11.667-5.221-11.667-11.667S9.054 3.833 15.5 3.833 27.167 9.054 27.167 15.5 21.946 27.167 15.5 27.167"
  })));
};
export default SvgCheckmarkGreen;